var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',{staticClass:"align-left"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):(_vm.rowData)?_c('div',[_c('b',[_vm._v(_vm._s(_vm.getContainerDetailParam(_vm.rowData.container, 'Mileage')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }